/* ============================================================
   GLTRverse — cart-recs.js
   Conditional "You may also like" in the cart drawer.
   Reads the product catalog rendered in cart-drawer.liquid and
   recomputes recommendations from the LIVE cart every time the
   drawer changes (theme.js only re-renders line items, not recs).
   Rules:
     Halo in cart     -> Brush, Celestial Glow Duo, Stardust
     Amber in cart    -> Brush, Cosmic Heat Duo, Stardust
     Stardust in cart -> Brush, Celestial Glow Duo, The Full Glow
     any Set in cart  -> the other two sets only
   Items already in the cart are never recommended.
   ============================================================ */
(function () {
  'use strict';

  var drawer = document.querySelector('.cart-drawer');
  if (!drawer) return;

  var catalog = (function () {
    var el = document.querySelector('script[data-cart-recs]');
    if (!el) return null;
    try {
      var txt = el.textContent.replace(/,(\s*})/g, '$1'); // tolerate a trailing comma
      var data = JSON.parse(txt);
      return data && data.catalog ? data.catalog : null;
    } catch (e) { return null; }
  })();

  var wrap = drawer.querySelector('[data-cart-recs-list]');
  var list = drawer.querySelector('[data-cart-recs-items]');
  if (!catalog || !wrap || !list) return;

  var SETS = ['celestial-glow-duo', 'cosmic-heat-duo', 'the-full-glow'];
  var RULES = {
    'shimmer-body-oil-halo':  ['shimmer-brush', 'celestial-glow-duo', 'shimmer-body-oil-stardust'],
    'shimmer-body-oil-amber': ['shimmer-brush', 'cosmic-heat-duo', 'shimmer-body-oil-stardust'],
    'shimmer-body-oil-stardust': ['shimmer-brush', 'celestial-glow-duo', 'the-full-glow']
  };
  var FALLBACK = ['shimmer-body-oil-stardust', 'celestial-glow-duo', 'the-full-glow'];

  function compute(items) {
    var inCart = {};
    (items || []).forEach(function (it) { if (it.handle) inCart[it.handle] = true; });
    var picks = [];
    function push(h) {
      if (!h || inCart[h] || !catalog[h]) return;
      if (picks.indexOf(h) === -1) picks.push(h);
    }
    if (SETS.some(function (s) { return inCart[s]; })) {
      SETS.forEach(function (s) { if (!inCart[s]) push(s); });
    } else {
      ['shimmer-body-oil-halo', 'shimmer-body-oil-amber', 'shimmer-body-oil-stardust'].forEach(function (oil) {
        if (inCart[oil]) RULES[oil].forEach(push);
      });
      if (!picks.length) FALLBACK.forEach(push);
    }
    return picks.slice(0, 3);
  }

  function render(cart) {
    var picks = compute(cart.items);
    if (!picks.length || cart.item_count === 0) {
      list.innerHTML = '';
      wrap.setAttribute('hidden', '');
      return;
    }
    list.innerHTML = picks.map(function (h) {
      var p = catalog[h];
      var safe = String(p.title || '').replace(/"/g, '&quot;');
      return '<div class="cart-rec">' +
        '<a href="' + p.url + '" class="cart-rec__img" style="background-image:url(\'' + (p.img || '') + '\')"></a>' +
        '<div class="cart-rec__info">' +
          '<a href="' + p.url + '" class="cart-rec__name">' + p.title + '</a>' +
          '<div class="cart-rec__price">' + p.price + '</div>' +
        '</div>' +
        '<form action="/cart/add" method="post" data-ajax-cart>' +
          '<input type="hidden" name="id" value="' + p.variant + '">' +
          '<button type="submit" class="cart-rec__add" aria-label="Add ' + safe + '"' + (p.available ? '' : ' disabled') + '>+</button>' +
        '</form>' +
      '</div>';
    }).join('');
    wrap.removeAttribute('hidden');
  }

  var pending = false;
  function refresh() {
    if (pending) return;
    pending = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); })
      .catch(function () {})
      .then(function () { pending = false; });
  }

  var itemsEl = drawer.querySelector('.cart-drawer__items');
  if (itemsEl && 'MutationObserver' in window) {
    new MutationObserver(function () { refresh(); }).observe(itemsEl, { childList: true });
  }
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      if (drawer.classList.contains('is-open')) refresh();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  refresh();
})();
